import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { NavLink } from "react-router-dom";

const ServiceCard = ({ index, icon, discription, title }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.2, once: true });

  const staggeredAnimation = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        delay: 0.225 * index,
      },
    }),
  };

  return (
    <motion.div
      ref={ref}
      variants={staggeredAnimation}
      initial={"hidden"}
      animate={isInView ? "visible" : "hidden"}
      whileHover={{
        scale: 1.05,
        cursor: "pointer",
        backgroundColor: "#1F3B7D",
        color: "white",
        transition: {
          type: "spring",
          stiffness: 150,
          duration: 0.1,
        },
      }}
      custom={index}
      className="col-span-1 flex h-full flex-col rounded-sm border-t-[0.35rem] border-t-visOrange bg-white px-2 py-5 shadow-visCardShadow"
    >
      <div className="flex h-full flex-col justify-between gap-5 px-2 py-8">
        <div className="h-full space-y-3">
          <div className="flex h-20 items-center justify-center">
            <img className="m-auto h-16 w-16" src={icon} alt="" />
          </div>
          <h2 className="text-center text-[1.375rem] font-semibold">{title}</h2>
          <p className="text-center">{discription}</p>
        </div>
        <NavLink
          to={"/services"}
          className="m-auto block w-fit rounded-sm bg-visOrange px-5 py-2 font-semibold text-white"
        >
          Read More
        </NavLink>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
